import React from 'react'

const ProgressBar = ({ value }) => {
    return (
        <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div
                className="h-full bg-[#03336e] transition-all shine rounded-full duration-500 ease-linear"
                style={{ width: `${value}%` }}
            />
        </div>
    )
}

export default ProgressBar